module.exports = __webpack_public_path__ + "img/01.f9fed60a.png";